import SharesPerCountry from './shares-per-country'

export default class InvoiceStakes {
  public shares: SharesPerCountry[] = []
  public netSum = 0
  public taxSum = 0
  public reminderCharges = 0
  public totalSum = 0
}